import React, { useEffect } from 'react';

const AutoLogout = () => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      localStorage.clear();
      alert("Sesi anda telah berakhir, silahkan Login kembali");
      window.location.reload("/");
    }, 3600000); 

    return () => clearTimeout(timeout);
  }, []);

  return null;
};

export default AutoLogout;

